import {
  createActions,
  asyncInitialState,
  asyncOnRequest,
  asyncOnSuccess,
  asyncOnError,
  asyncSelectors,
} from "./utils";

export const { types, actions } = createActions(
  {
    asyncs: {
      getSalesList: (data) => data,
    },
  },
  "salesList"
);

let initialState = asyncInitialState({
  salesList: null,
  errorMessage: "",
  success: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.getSalesList:
      return asyncOnRequest(state, action);
    case types.saga.getSalesList.success:
      return asyncOnSuccess(state, action, (data, action) => {
        return {
          ...data,
          salesList: action.payload.data,
          errorMessage: "",
        };
      });
    case types.saga.getSalesList.failure:
      return asyncOnError(state, action);
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors((state) => state.salesList, {
  errorMessage: (data) => data.errorMessage,
});

const syncSelector = {
  isLoading: (state) => state.salesList.loading,
  salesList: (state) => state.salesList.data.salesList,
};

export const selectors = Object.assign({}, asyncSelector, syncSelector);
